import { render, staticRenderFns } from "./AddToWishList.vue?vue&type=template&id=bc6a6626&"
import script from "./AddToWishList.vue?vue&type=script&lang=js&"
export * from "./AddToWishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports